/**
 * main.js — 应用入口
 * 初始化 Vue 实例，注册全局插件和组件
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'

// 全局样式 & 移动端适配
import '@/mobile/flexible'
import '@/styles/reset.css'

// Vant UI 组件按需引入
import {
  Tabbar,
  TabbarItem,
  Col,
  Row,
  Image as VanImage,
  Icon,
  Lazyload,
  NavBar,
  Search
} from 'vant'

const app = createApp(App)

// 路由
app.use(router)

// Vant 组件注册
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Col)
app.use(Row)
app.use(VanImage)
app.use(Icon)
app.use(Search)
app.use(Lazyload, { lazyComponent: true })

// 挂载
app.mount('#app')